module.exports = __webpack_public_path__ + "static/media/facebook.7952bba2.svg";